import React from 'react';

import { Section, Lines } from './styles';

function BackgroundLines() {
  return (
    <Section className="bg-lines">
      <Lines />
    </Section>
  );
}

export default BackgroundLines;
